import React, { lazy } from 'react';
export function HeroSection() {
  const scrollToProtocolo = () => {
    const el = document.getElementById('protocolo');
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative px-4 sm:px-[5%] py-8 sm:py-16 md:py-20 flex flex-col items-center text-center overflow-hidden min-h-[65vh] sm:min-h-[80vh] md:min-h-[90vh] justify-center" role="banner" data-id="element-81">
      {/* Background — above-fold, eager load for LCP */}
      <img src="https://cdn.magicpatterns.com/uploads/8xQfzimBtPz32cPQNu11v2/el-hero-visual-fondo-de-red-neuronal.webp" alt="" aria-hidden="true" loading="eager" decoding="async" fetchPriority="low" className="absolute inset-0 w-full h-full object-cover opacity-35 z-0 pointer-events-none" data-id="element-82" />

      {/* Gradient overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0B] via-transparent to-[#0A0A0B] z-[1]" aria-hidden="true" data-id="element-83" />

      {/* Content — renders instantly, no JS dependency */}
      <div className="relative z-10 max-w-4xl animate-fadeInUp" data-id="element-84">
        <span className="inline-block bg-yellow-500/10 text-gold px-3 sm:px-4 py-1 sm:py-1.5 rounded-full text-[9px] sm:text-[10px] font-black tracking-[2px] sm:tracking-[3px] mb-3 sm:mb-6 uppercase border border-yellow-500/20" data-id="element-85">
          OFERTA DE ACCESO INMEDIATO
        </span>

        <h1 className="font-serif text-[28px] sm:text-5xl md:text-7xl lg:text-8xl leading-[1.1] font-black mb-3 sm:mb-6" data-id="element-86">
          PROGRAMACIÓN <br data-id="element-87" />
          <span className="text-gold" data-id="element-88">NEURO-CUÁNTICA</span>
        </h1>

        <p className="text-sm sm:text-lg md:text-xl opacity-90 leading-relaxed mb-5 sm:mb-10 max-w-2xl mx-auto font-medium px-2 sm:px-0" data-id="element-89">
          Aprende a sintonizar tu sistema nervioso con la frecuencia de la
          abundancia mediante un protocolo diario de solo 15 minutos.
        </p>

        <div className="flex flex-col items-center gap-2.5 sm:gap-4" data-id="element-90">
          <button onClick={scrollToProtocolo} className="bg-gold text-dark py-3.5 sm:py-6 px-6 sm:px-12 text-sm sm:text-xl font-black rounded-xl shadow-[0_15px_40px_rgba(212,175,55,0.35)] hover:scale-105 active:scale-95 transition-all w-full max-w-[300px] sm:max-w-md" data-id="element-91">
            DECRETO MI ABUNDANCIA AHORA
          </button>
          <p className="text-[10px] sm:text-xs text-gold/70 mt-2 tracking-wider font-medium" data-id="element-92">
            Haz clic para activar el Código 888
          </p>
          <p className="text-[8px] sm:text-[10px] font-bold text-gold tracking-[2px] sm:tracking-[3px] uppercase mt-1 sm:mt-2" aria-hidden="true" data-id="element-93">
            ⚡ ACCESO DIGITAL • PAGO ÚNICO
          </p>
          <div className="flex flex-col gap-1 sm:gap-2 mt-1.5 sm:mt-4 items-center" data-id="element-94">
            <div className="flex items-center gap-1.5 sm:gap-2 text-white/75 text-[10px] sm:text-xs" data-id="element-95">
              <span className="text-gold" data-id="element-96">🔒</span>
              <span data-id="element-97">Pago 100% seguro con PayPal y tarjeta</span>
            </div>
            <div className="flex items-center gap-1.5 sm:gap-2 text-white/75 text-[10px] sm:text-xs" data-id="element-98">
              <span className="text-gold" data-id="element-99">✅</span>
              <span data-id="element-100">Garantía de devolución de 30 días sin preguntas</span>
            </div>
          </div>
        </div>
      </div>

      {/* Product Image — LCP element, highest priority */}
      <div className="mt-8 sm:mt-16 relative z-10 w-full flex justify-center" data-id="element-101">
        <img src="https://cdn.magicpatterns.com/uploads/okWoSELjHgwdJXzrY54pLG/chatgpt-image-5-abr-2026-03-38-29-pm.webp" alt="EL CÓDIGO 888" width={350} height={452} className="w-full max-w-[180px] sm:max-w-[240px] md:max-w-[350px] shadow-[0_30px_60px_rgba(0,0,0,0.8)] animate-float rounded-xl" loading="eager" decoding="sync" fetchPriority="high" data-id="element-102" />
      </div>
    </section>;
}